export default {
  primary: '#4C7AEC',
  sharkish: '#4B4F52',
  ultramarine: '#1A1796',
}
